import e from "../managers/braze-instance.js";
import r from "../../shared-lib/braze-shared-lib.js";
export function getDeviceId(t) {
  if (!e.rr()) return;
  const i = e.te();
  if (!i) return;
  const c = i.ce().id;
  if ("function" != typeof t) return c;
  r.j.warn(
    "The callback for getDeviceId is deprecated. You can access its return value directly instead (e.g. `const id = braze.getDeviceId()`)",
  ),
    t(c);
}
